import React, { useState, useEffect } from "react";
import { FaTimes, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

const AlertNotification = ({ text, onClose, status }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onClose && onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClose = () => {
    setIsVisible(false);
    onClose && onClose();
  };

  if (!isVisible) return null;

  const isSuccess = status === true;

  const styles = {
    toastContainer: {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      zIndex: 9999,
      animation: "slideIn 0.4s ease-out",
    },
    toastContent: {
      padding: "12px 16px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      minWidth: "260px",
      maxWidth: "600px",
    },
    message: {
      fontSize: "14px",
      fontWeight: 500,
      flex: 1,
      wordWrap: "break-word",
    },
    closeButton: {
      background: "none",
      border: "none",
      color: "inherit",
      cursor: "pointer",
      fontSize: "16px",
    },
    icon: {
      fontSize: "18px",
    },
  };

  return (
    <div style={styles.toastContainer}>
      <div
        style={styles.toastContent}
        className={`border shadow-[0_2px_10px_rgba(0,0,0,0.1)] dark:shadow-black/40 ${
          isSuccess
            ? "border-emerald-500 bg-emerald-100 text-emerald-800 dark:border-emerald-500/60 dark:bg-emerald-950 dark:text-emerald-200"
            : "border-red-500 bg-red-100 text-red-800 dark:border-red-500/60 dark:bg-red-950 dark:text-red-200"
        }`}
      >
        {isSuccess ? (
          <FaCheckCircle style={styles.icon} />
        ) : (
          <FaExclamationTriangle style={styles.icon} />
        )}
        <span style={styles.message}>{text}</span>
        <button onClick={handleClose} style={styles.closeButton}>
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

// Inject animation only once
const styleSheet = document.styleSheets[0];
if (![...styleSheet.cssRules].some(rule => rule.name === "slideIn")) {
  styleSheet.insertRule(`
    @keyframes slideIn {
        from {
            transform: translateY(100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }`, styleSheet.cssRules.length);
}

export default AlertNotification;
